import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "overflow-hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cursor = _resolveComponent("cursor")!
  const _component_preloader = _resolveComponent("preloader")!
  const _component_fixed_nav = _resolveComponent("fixed-nav")!
  const _component_page = _resolveComponent("page")!
  const _component_p_w_a_prompt = _resolveComponent("p-w-a-prompt")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_cursor),
    _createVNode(_component_preloader),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_fixed_nav),
      _createVNode(_component_page),
      _createVNode(_component_p_w_a_prompt)
    ])
  ]))
}